import { link } from "fs";

const PRODUCT_LIST = [
  {
    name: "picker",
    link: "jumbo-picker",
    descriptionKey: "picker-mega-menu-description",
  },
  {
    name: "forms",
    link: "jumbo-forms",
    descriptionKey: "forms-mega-menu-description",
  },
  {
    name: "pay",
    link: "jumbo-pay",
    descriptionKey: "pay-mega-menu-description",
  },
];

export default PRODUCT_LIST;
